import React from 'react'
import $ from 'jquery';
import Page from '../Page'
import { QueryParam, API_FAQ , BASE_URL } from '../Util'
import { Row, Col, Collapsible, CollapsibleItem } from 'react-materialize'
import Sticky from 'react-sticky-el';
import * as rdd from 'react-device-detect';
class FAQ extends Page {

  constructor(props) {
      super(props);
      let params = QueryParam();
      this.state = {
        tab : 0, 
        query : params.query
      }
  }

  componentDidMount() {
    this.handleLoadData();  
  }
  
  componentDidUpdate() {
    if(this.state.data){
      this.checkForLink()
    }
  }

  handleLoadData(month) {

    $.getJSON(API_FAQ, {month : month})
      .then((data) => {
        let sections = data.payload;
        let tab = this.state.tab;

        if (this.state.query) {
          for(let i in sections) {
            if (sections[i].title == this.state.query) {
              tab = i;
            }
          }
        }

        this.setState({ data: sections, tab : tab });
      });
  }

  checkForLink = () => {
    const {data, tab} = this.state
    const match = data[tab].contents.map((item) => {return{"answer": item.answer.replace(/<a([^>]*)>/, '<a$1 target="_blank" style="color: #134b95">'), "question": item.question} })
    data[tab].contents = match
  }

  handleDaftarIsi = (i) => {
    this.setState({tab : i})
    if(rdd.isMobile){
      const contentTitle = document.querySelector('.content-title')      
      this.scrollToTop(contentTitle.offsetTop - 100)
    }else{
      this.scrollToTop(650)
    }
  }
  
  render() {
    let sections = this.state.data;
    let tab = this.state.tab
    let activeSection = sections ? sections[tab] : null

    return (
      <div className="pb-m border-bottom">
        <div className="bg-banner ptb-l">
          <Row className="container valign-wrapper">
            <Col s={12}>
              <h4 className="font-white font-light">FAQ - PROGRAM KARTU PRAKERJA GETI INCUBATOR!</h4>
            </Col>
          </Row >
        </div>
        {/* <div className="mt-m container narrow"> */}
          <Row className="container valign-wrapper">
            <Col className="pad-m bg-white" s={12}>
            <div ><b>Halo, Getters!</b></div>
              <p >Terima kasih sudah memilih GETI Incubator sebagai mitra pelatihan Kartu Prakerja Anda. Kami memiliki komitmen untuk terus menghadirkan pengalaman belajar yang atraktif dan aplikatif untuk seluruh peserta. Kami juga berharap materi yang dihadirkan akan memberikan manfaat bagi seluruh peserta, khususnya dalam membuka peluang-peluang baru dalam bidang bisnis dan pekerjaan sehingga membantu Anda dalam meraih karier impian.</p>
              <p >Berikut kami rangkum sejumlah pertanyaan beserta jawaban yang sering ditanyakan oleh peserta terkait pelatihan Kartu Prakerja di GETI Incubator. Untuk mendapatkan jawaban cepat dari pertanyaan umum, Anda bisa mengecek daftar pertanyaan berikut terlebih dahulu.</p>
              <p >Apabila masih ada pertanyaan yang belum terjawab, Anda dapat menghubungi kami di <b>prakerja2@geti.id</b> atau chat via DM di Instagram @geti.prakerja. Kami sangat menyarankan untuk menghubungi admin lewat chat WhatsApp di nomor <b>0811 9309 114</b>, karena kami akan melayani 24 jam non stop. Tim GETI Incubator sedang berusaha semaksimal mungkin agar bisa cepat menjawab pertanyaan-pertanyaan yang masuk. Anda tidak perlu khawatir jika belum di respon, mohon berkenan menunggu, Getters!</p>
            </Col>
          </Row>
        {/* </div> */}
        <div className="mt-m container narrow">
          {!sections && this.getLoadingMedium()}
          {sections && 
          <Row>
            <Col m={3} s={12} className="strong">
              <div className="pad-m-s">
              <Sticky hideOnBoundaryHit={false} boundaryElement=".narrow" topOffset={-110} stickyStyle ={{"paddingTop" : "110px"}}>
              <h5 className="black-text mb-s font-large">Daftar Isi</h5>
              {sections.map((section, i)=>
                <div className="strong font-medium mb-s"><a onClick={()=>this.handleDaftarIsi(i)} className={i == tab ? "font-orange" : "font-grey"}>{section.title}</a></div>
              )}
              <br/><br/>
              </Sticky>
              </div>
            </Col>
            <Col className="pad-m bg-white" m={9} s={12}>
              <h5 className="content-title font-large mb-s">{activeSection.title}</h5>
              {activeSection.contents &&
              <Collapsible className="no-border">
              {activeSection.contents.map((content, i) =>
                <CollapsibleItem 
                  expanded={i == 0} 
                  header={<div className="font-medium mr-m">{content.question}</div>} icon='keyboard_arrow_up' 
                >
                  <div className="justify" dangerouslySetInnerHTML={{__html: content.answer}}></div>
                </CollapsibleItem>
              )}
              </Collapsible>
              }

              {!activeSection.contents && "Konten belum tersedia"}
            </Col>
         
          </Row>
          }
        </div>

      </div>
      )
  }
}

export default FAQ



// WEBPACK FOOTER //
// ./src/components/Public/FAQ.js